import {createReducer, on} from '@ngrx/store';
import * as CustomConfigurationActions from './custom-configuration.actions';

export const customConfigurationFeatureKey = 'customConfiguration';

export interface CustomConfiguration {
  tableColumns?: string[];
  hierarchicalTableColumns?: string[];
}


// eslint-disable-next-line
export interface State extends CustomConfiguration {
  tableColumns: string[];
  hierarchicalTableColumns: string[];
}

export const initialState: State = {
  tableColumns: [],
  hierarchicalTableColumns: []
};

export const reducer = createReducer(
  initialState,
  on(CustomConfigurationActions.loadCustomConfigurationsSuccess,
    CustomConfigurationActions.saveCustomConfigurationSuccess, (state, action) => ({
      ...state,
      tableColumns: action.config.tableColumns || [],
      hierarchicalTableColumns: action.config.hierarchicalTableColumns || []
    })),
);
